import styled from "styled-components";

export const SpecialFieldLabel = styled.div`
  color: white;
  font-weight: bold;
  transform: translate(-50%, -50%) rotate(90deg);
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 1.2em;
`;
